<mat-form-field class="language-select" style="width: auto">
  <mat-select
    [matBadge]
    hideSingleSelectionIndicator
    [placeholder]="profile?.info.name ? profile?.info.name : profile?.info.preferred_username"
  >
    <mat-option (click)="getActuatorInfo()">
      <fa-icon class="circle" size="lg" [fixedWidth]="true" [icon]="'info'"></fa-icon>
      {{ 'APPLAYOUT.HEADER.ABOUT' | translate }}
    </mat-option>
    <mat-option (click)="displayErrorLog()" [disabled]="!hasErrorsToDisplay()">
      <fa-icon class="circle" size="lg" [fixedWidth]="true" [icon]="'bug'"></fa-icon>
      {{ 'APPLAYOUT.HEADER.ERROR_LOG.LABEL' | translate }}
    </mat-option>
    <mat-option (click)="logout()">
      <fa-icon class="circle" size="lg" [fixedWidth]="true" [icon]="'sign-out-alt'"></fa-icon>
      {{ 'APPLAYOUT.HEADER.LOGOUT' | translate }}
    </mat-option>
  </mat-select>
</mat-form-field>
